export const environment = {
  production: false,
  apiUrl: 'https://pipeupapidev.azurewebsites.net/api',
  avatarBaseUrl: '',
  stripePublishableKey: 'pk_test_51OY7pjLUEGZlUoPazd3l5sIqnlKlT3q0DfLBksCBVBjk39uUicbegJSi1J1yZd9vu95wzT3B5EEtgjsHokRvdy1200OmufbN0R',
  transfeeraWebhookSecret: '',
  features: {
    FF_PRODUCT_PRICE_GUARDRAILS: true, // FASE 1: Guardrails no cadastro de produto
    FF_PROPOSAL_ITEM_PRICE_GUARDRAILS: true, // FASE 2: Guardrails nos itens da proposta
    FF_REQUIRE_REASON_OUT_OF_RANGE: false // FASE 2: Exigir motivo quando fora da faixa (usa requireReasonOutOfRange do produto)
  }
};
